import React, {useEffect } from 'react';

import {useAuthentication} from "@careers-wales/react-components";

function AnalyticsEvent({ event,trigger = 1 }) {
    const { isAuthenticated, account } = useAuthentication();

    useEffect(() => {

            if (window.dataLayer) {
                const pageView = {
                    event: event
                    // authenticated: isAuthenticated(),
                    // authenticatedMethod: isAuthenticated()
                    //     ? `${account().idTokenClaims.authenticationMethod} ${account().idTokenClaims.socialIssuer || 'Email'}`
                    //     : null,
                    // authenticatedError: account() ? account().idTokenClaims.authenticationError || null : null
                };

                window.dataLayer.push(pageView);
                console.info('Triggering analytics event: ', pageView);
            }

    },[trigger]);


    return <></>;
}


export default AnalyticsEvent;
